import {
    DELETE_ACCOUNT_USERS,
    DELETE_ACCOUNT_USERS_FAILURE,
    DELETE_ACCOUNT_USERS_SUCCESS,
} from 'store/actions/types';

export const deleteAccountUsers = (payload) => {
    return {
        type: DELETE_ACCOUNT_USERS,
        payload: payload,
    };
};

export const deleteAccountUsersFailure = (error) => {
    return {
        type: DELETE_ACCOUNT_USERS_FAILURE,
        error: error,
    };
};

export const deleteAccountUsersSuccess = (payload) => {
    return {
        type: DELETE_ACCOUNT_USERS_SUCCESS,
        payload: payload,
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/accounts/users/deleteAccountUsers.js